import { Grid, Tooltip } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent, useMemo } from "react";
import BaseEntity from "../../../../models/BaseEntity";
import { ClassifierResult } from "../../../../models/ClassifierResult";
import { useStore } from "../../../../utils/useStore";
import AcxAnswerSelector, {
    AnswerColor,
    AnswerSelection,
} from "../../../UI/AcxAnswerSelector";
import AcxChipList from "../../../UI/AcxChipList";
import { EvalStore } from "../../Stores/EvalStore";

class ValidationResultAnswer extends BaseEntity {
    constructor(result: "true" | "false") {
        super();
        this.id = result as string;
        this.result = result;
    }
    result: "true" | "false";
}
// Array<{ data: T; option: AnswerSelection }>;
const validationResultOptions: Array<{
    data: ValidationResultAnswer;
    option: AnswerSelection;
}> = [
    {
        data: new ValidationResultAnswer("true"),
        option: { text: "Yes", color: AnswerColor.DARKBLUE },
    },
    {
        data: new ValidationResultAnswer("false"),
        option: { text: "No", color: AnswerColor.DARKBLUE },
    },
];

interface OwnProps {
    classifierResult: ClassifierResult;
    isDisabled?: boolean;
}

type Props = OwnProps;

const ClassifierFeedbackAnswer: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = observer((props) => {
    const store = useStore(EvalStore);

    const classifierValidation =
        store.currentEval?.getClassifierValidationForResult(
            props.classifierResult,
        );
    const validationResult = useMemo(
        () =>
            classifierValidation?.result
                ? new ValidationResultAnswer(classifierValidation.result)
                : undefined,
        [classifierValidation],
    );

    function onValidationResult(
        validationResultAnswer?: ValidationResultAnswer,
    ) {
        if (!props.isDisabled) {
            if (validationResultAnswer === undefined) {
                store.currentEval?.setValidationForClassificationResult(
                    props.classifierResult,
                    undefined,
                    classifierValidation,
                );
            } else {
                store.currentEval?.setValidationForClassificationResult(
                    props.classifierResult,
                    validationResultAnswer.result,
                    classifierValidation,
                );
            }
        }
    }

    return (
        <Grid
            item
            xs={12}
            container
            direction={"column"}
            justifyContent={"flex-start"}
            alignItems="stretch"
        >
            <Grid
                item
                xs={12}
                container
                direction={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                wrap={"nowrap"}
                spacing={4}
                sx={{
                    marginBottom: 1,
                    marginTop: 2,
                    paddingRight: 3,
                    paddingLeft: 3,
                }}
            >
                <Grid item lg={2} md={6} sm={6} xs={6}>
                    <Tooltip
                        title={props.classifierResult.classifier.name}
                        placement={"top"}
                    >
                        <div>
                            <AcxChipList
                                size={"small"}
                                color={"blue"}
                                values={[
                                    props.classifierResult.classifier.name,
                                ]}
                            />
                        </div>
                    </Tooltip>
                </Grid>
                <Grid
                    item
                    lg={3}
                    md={6}
                    sm={6}
                    xs={6}
                    container
                    justifyContent={"flex-end"}
                >
                    <AcxAnswerSelector
                        options={validationResultOptions}
                        onSelect={onValidationResult}
                        defaultValue={validationResult}
                        isDisabled={props.isDisabled}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
});

export default ClassifierFeedbackAnswer;
